import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import auditService from '../services/auditService';

const Settings = () => {
  const { admin } = useAuth();
  const canManage = admin?.role === 'super_admin';
  const [recordLogViews, setRecordLogViews] = useState(null);
  const [reload, setReload] = useState(0);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!canManage) return undefined;
    let active = true;
    setLoading(true);
    setError('');
    auditService.getSettings().then(res => {
      if (!res.success) throw new Error(res.message || 'Unable to fetch settings');
      if (active) setRecordLogViews(res.data.record_log_views);
    }).catch(err => {
      if (active) setError(err.response?.data?.message || err.message || 'Unable to fetch settings');
    }).finally(() => {
      if (active) setLoading(false);
    });
    return () => { active = false; };
  }, [canManage, reload]);

  const toggleLogViews = async () => {
    setSaving(true);
    setError('');
    setMessage('');
    try {
      const res = await auditService.updateSettings({ record_log_views: !recordLogViews });
      if (!res.success) throw new Error(res.message || 'Unable to save settings');
      setRecordLogViews(res.data.record_log_views);
      setMessage('Audit settings saved.');
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Unable to save settings');
    } finally {
      setSaving(false);
    }
  };

  if (!canManage) return <div className="card" style={{ padding: '2rem' }}>Super Admin access is required to manage settings.</div>;

  return (
    <div className="card" style={{ padding: '1.5rem', maxWidth: '850px' }}>
      <h2 style={{ margin: '0 0 0.5rem', fontSize: '1.1rem' }}>Audit Logs</h2>
      <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginBottom: '1.5rem' }}>Manage recording of Audit Logs viewing activity.</p>
      {loading ? <p>Loading settings...</p> : (
        <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'center', flexWrap: 'wrap', borderTop: '1px solid var(--border-light)', paddingTop: '1.25rem' }}>
          <div style={{ flex: '1 1 300px' }}>
            <h3 id="log-views-label" style={{ margin: '0 0 0.5rem', fontSize: '0.95rem' }}>Record Audit Logs views</h3>
            <p id="log-views-description" style={{ margin: 0, color: 'var(--text-secondary)', fontSize: '0.85rem', lineHeight: 1.6 }}>
              Disabled by default. When disabled, opening, filtering, paging and viewing log details do not create audit entries. When enabled, only access metadata is recorded.
            </p>
          </div>
          <button type="button" role="switch" aria-checked={recordLogViews === true} aria-labelledby="log-views-label" aria-describedby="log-views-description"
            className={`btn ${recordLogViews ? 'btn-primary' : 'btn-outline'}`} disabled={saving || recordLogViews === null} onClick={toggleLogViews}>
            {saving ? 'Saving...' : recordLogViews === null ? 'Unavailable' : recordLogViews ? 'Enabled' : 'Disabled'}
          </button>
        </div>
      )}
      {error && <p role="alert" style={{ color: 'var(--error)', marginTop: '1rem' }}>{error}</p>}
      {!loading && recordLogViews === null && <button className="btn btn-outline" type="button" onClick={() => setReload(value => value + 1)}>Retry</button>}
      {message && <p role="status" style={{ color: 'var(--success)', marginTop: '1rem' }}>{message}</p>}
    </div>
  );
};

export default Settings;
